import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=78b75044&scoped=true"
import script from "./Publication.vue?vue&type=script&setup=true&lang=js"
export * from "./Publication.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Publication.vue?vue&type=style&index=0&id=78b75044&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b75044",
  null
  
)

export default component.exports